import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
const styles = theme => ({
    root: {
        flexGrow: 1
    },
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '2em',
        outline: 'none',
        borderRadius: '1em'
    },
    button: {
        color: '#fca66f',
        margin: '1em',
        float: 'right'
    }
});

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}
class ModalNoLaborable extends Component {
    render() {
        const { classes } = this.props;
        return <div>
            <Modal
                aria-labelledby="Atención"
                aria-describedby="simple-modal-description"
                open={this.props.open}
            >
                <div style={getModalStyle()} className={classes.paper}>
                    <Typography variant="headline" id="modal-title">
                        <strong>El plazo</strong> corresponde a un <strong>día no hábil </strong>
                        y <strong>se ajustará automáticamente </strong> al próximo día
                        hábil.
                            </Typography>
                    <Button className={classes.button} onClick={() => this.props.action(false)}>cerrar</Button>
                </div>
            </Modal>
        </div>;
    }
}
ModalNoLaborable.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(ModalNoLaborable);



// WEBPACK FOOTER //
// ./src/components/PlazoFijo/datosPersonales/error/ModalNoLaborable.js